// Centralized iOS-app detection used across the React frontend to comply
// with Apple Guidelines 3.1.1 / 3.1.3(b). When running inside the native
// iOS WebView (Capacitor), the app MUST NOT expose any UI/flow related to:
//   - company account registration (titolare)
//   - subscription plans / pricing
//   - payment processors (Stripe, PayPal)
//   - external links to the marketing website
// Employee (dipendente) registration with an invite code IS allowed: it
// involves no purchase. On web and Android the app remains fully featured.

export function isIOSApp() {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor || null;
  if (cap) {
    try {
      if (typeof cap.getPlatform === "function" && cap.getPlatform() === "ios") return true;
    } catch (e) {
      // ignore
    }
    if (cap.platform === "ios") return true;
  }
  // Fallback heuristic: iOS device in an embedded WebView (not regular Safari)
  // Also covers modern iPads that report as desktop Mac in userAgent.
  if (typeof navigator !== "undefined") {
    const ua = (navigator.userAgent || "").toLowerCase();
    const isIPad = /ipad/.test(ua) || (navigator.platform === "MacIntel" && (navigator.maxTouchPoints || 0) > 1);
    const isIPhone = /iphone|ipod/.test(ua);
    const isStandaloneWebView = (isIPad || isIPhone) && !/safari/.test(ua);
    return isStandaloneWebView;
  }
  return false;
}
